import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/journalDiagnostic/search', { params: request })
  },
  find: function (id) {
    return axios.get('/api/journalDiagnostic/find?id='+id)
  },
  save: function (data) {
    return axios.post('/api/journalDiagnostic/save', data)
  },
  delete: function (id) {
    return axios.delete('/api/journalDiagnostic/delete?id='+id)
  },
  approve: function (id) {
    return axios.get('/api/journalDiagnostic/approve?id='+id)
  },
  
  loadOrganizations: function(search) {
    return axios.get('/api/organizations/getList?search=' + search)
  },
  loadEmployees: function(orgId) {
    return axios.get('/api/organizations/getEmployeeList?organizationId=' + orgId)
  },
  saveDiagnosticDateEnter: function(data) {
    return axios.post('/api/journalDiagnostic/saveDiagnosticDateEnter', data)
  }
}